define(["require", "exports", "./analytics", "./jquery-plugins/draggable", "./context"], function (require, exports, analytics_1, draggable_1, context_1) {
    "use strict";
    exports.__esModule = true;
    function isCanvas(x) {
        return x.tagName === 'CANVAS';
    }
    exports.isCanvas = isCanvas;
    function isImg(x) {
        return x.tagName === 'IMG';
    }
    exports.isImg = isImg;
    function isIPhone() {
        return context_1["default"].isMobile() && draggable_1.isIOS;
    }
    var CanvasPainter = (function () {
        function CanvasPainter(_canvas, _context) {
            this._canvas = _canvas;
            this._context = _context;
            this._context = this._context || this._canvas.getContext('2d');
        }
        CanvasPainter.prototype.reset = function () {
            var $canvas = $(this._canvas);
            this._context.clearRect(0, 0, Number($canvas.attr('width')), Number($canvas.attr('height')));
            return this;
        };
        CanvasPainter.prototype.setBackgroundColor = function (color) {
            var $canvas = $(this._canvas);
            this._context.clearRect(0, 0, Number($canvas.attr('width')), Number($canvas.attr('height')));
            this._context.fillStyle = color;
            this._context.fillRect(0, 0, Number($canvas.attr('width')), Number($canvas.attr('height')));
            return this;
        };
        CanvasPainter.prototype.drawPictureInside = function (picture) {
            var $canvas = $(this._canvas);
            var width = Number($canvas.attr('width'));
            var height = Number($canvas.attr('height'));
            var pictureWidth = 0;
            var pictureHeight = 0;
            if (isCanvas(picture)) {
                pictureWidth = Number(picture.getAttribute('width'));
                pictureHeight = Number(picture.getAttribute('height'));
            }
            else {
                pictureWidth = picture.naturalWidth;
                pictureHeight = picture.naturalHeight;
            }
            pictureWidth = Math.floor(pictureWidth);
            pictureHeight = Math.floor(pictureHeight);
            var maxWidth = Math.round(Math.min(pictureWidth, width * 0.9));
            var maxHeight = Math.round(Math.min(pictureHeight, height * 0.9));
            var scale = Math.min(maxWidth / pictureWidth, maxHeight / pictureHeight);
            var targetWidth = Math.round(pictureWidth * scale);
            var targetHeight = Math.round(pictureHeight * scale);
            var left = Math.round((width - targetWidth) / 2);
            var top = Math.round((height - targetHeight) / 2);
            this._context.drawImage(picture, 0, 0, pictureWidth, pictureHeight, left, top, targetWidth, targetHeight);
            return this;
        };
        return CanvasPainter;
    }());
    exports.CanvasPainter = CanvasPainter;
    function resetCanvas(canvas, context) {
        context = context || canvas.getContext('2d');
    }
    exports.resetCanvas = resetCanvas;
    function scalePicture(picture, maxWidth, maxHeight) {
        var origWidth = isCanvas(picture) ? picture.width : picture.naturalWidth;
        var origHeight = isCanvas(picture) ? picture.height : picture.naturalHeight;
        var scaleX = Math.min(1, maxWidth / origWidth);
        var scaleY = Math.min(1, maxHeight / origHeight);
        var scale = Math.min(scaleX, scaleY);
        if (scale === 1) {
            return picture;
        }
        var imgWidth = Math.round(origWidth * scale);
        var imgHeight = Math.round(origHeight * scale);
        var width = imgWidth;
        var height = imgHeight;
        var $target = $("<canvas width='" + width + "' height='" + height + "'/>");
        var target = $target[0];
        var context = target.getContext('2d');
        context.drawImage(picture, 0, 0, width, height);
        return target;
    }
    exports.scalePicture = scalePicture;
    function degToRad(deg) {
        return Math.PI * deg / 180;
    }
    exports.degToRad = degToRad;
    function rotatePicture(picture, deg) {
        var rotate = parseInt(deg) % 360;
        if (isNaN(rotate) || rotate === 0) {
            return picture;
        }
        var origWidth = isCanvas(picture) ? picture.width : $(picture).width();
        var origHeight = isCanvas(picture) ? picture.height : $(picture).height();
        var width = (rotate % 180) === 0 ? origWidth : origHeight;
        var height = (rotate % 180) === 0 ? origHeight : origWidth;
        var target = $("<canvas width='" + width + "' height='" + height + "' class='rotate-clock-wise'/>")[0];
        var context = target.getContext('2d');
        var angle = degToRad(rotate);
        context.translate(width / 2, height / 2);
        context.rotate(angle);
        context.drawImage(picture, -origWidth / 2, -origHeight / 2, origWidth, origHeight);
        context.rotate(-angle);
        context.translate(-width / 2, -height / 2);
        return target;
    }
    exports.rotatePicture = rotatePicture;
    function composeImageAsBackground(img, canvas) {
        var width = canvas.width;
        var height = canvas.height;
        var $result = $("<canvas width=\"" + width + "\" height=\"" + height + "\"/>");
        var result = $result[0];
        var context = result.getContext('2d');
        context.drawImage(img, 0, 0, width, height);
        context.drawImage(canvas, 0, 0, width, height);
        return result;
    }
    exports.composeImageAsBackground = composeImageAsBackground;
    function composeCanvasAsBackground(canvas, inner) {
        var width = canvas.width;
        var height = canvas.height;
        var result = $("<canvas width=\"" + width + "\" height=\"" + height + "\"/>")[0];
        var context = result.getContext('2d');
        var $inner = $(inner);
        context.drawImage(canvas, 0, 0, width, height);
        context.drawImage(inner, parseInt($inner.css('left')), parseInt($inner.css('top')), inner.width, inner.height);
        return result;
    }
    exports.composeCanvasAsBackground = composeCanvasAsBackground;
    function canvasAsJpegDataUri(canvas, quality) {
        if (quality === void 0) { quality = 0.5; }
        return canvas.toDataURL("image/jpeg", quality);
    }
    exports.canvasAsJpegDataUri = canvasAsJpegDataUri;
    function dataUriToFile(dataUri) {
        var index = dataUri.indexOf(';base64,');
        if (index <= 5) {
            return null;
        }
        var mimeType = dataUri.substr(5, index - 5);
        var baseIndex = index + 8;
        var base64 = dataUri.substr(baseIndex);
        var content = atob(base64);
        var bytes = new Uint8Array(content.length);
        for (var i = 0; i < content.length; i++) {
            bytes[i] = content.charCodeAt(i);
        }
        try {
            var file = new File([bytes], "image.jpg", { type: mimeType });
            return file;
        }
        catch (err) {
            var blob = new Blob([bytes], { type: mimeType });
            blob.name = 'image.jpg';
            blob.lastModifiedDate = new Date();
            return blob;
        }
    }
    exports.dataUriToFile = dataUriToFile;
    function canvasToJpegFile(canvas, maxWidth, maxHeight) {
        if (maxWidth === void 0) { maxWidth = 800; }
        if (maxHeight === void 0) { maxHeight = 1200; }
        try {
            analytics_1["default"]('canvasToJpegFile', 'start');
            var target = scalePicture(canvas, maxWidth, maxHeight);
            analytics_1["default"]('canvasToJpegFile', 'scaled');
            var dataUri = canvasAsJpegDataUri(target);
            analytics_1["default"]('canvasToJpegFile', 'dataUri');
            return dataUriToFile(dataUri);
        }
        catch (err) {
            analytics_1["default"]('exception', 'canvasToJpegFile', JSON.stringify(err));
            return null;
        }
    }
    exports.canvasToJpegFile = canvasToJpegFile;
    function canvasToDataUri(canvas, maxWidth, maxHeight) {
        try {
            var target = scalePicture(canvas, maxWidth, maxHeight);
            var dataUri = canvasAsJpegDataUri(target);
            return dataUri;
        }
        catch (err) {
            analytics_1["default"]('exception', 'canvasToDataUri', JSON.stringify(err));
            return null;
        }
    }
    exports.canvasToDataUri = canvasToDataUri;
    function scaleImageAsFile(img, fileName, mimeType, maxWidth, maxHeight) {
        var deferred = $.Deferred();
        var result = scalePicture(img, maxWidth, maxHeight);
        if (isCanvas(result)) {
            var dataUri = canvasAsJpegDataUri(result, 0.8);
            deferred.resolve({
                file: dataUriToFile(dataUri),
                width: result.width,
                height: result.height
            });
        }
        else {
            var xhr_1 = new XMLHttpRequest();
            xhr_1.open('GET', $(result).attr('src'), true);
            xhr_1.responseType = 'blob';
            xhr_1.onload = function () {
                if (xhr_1.status === 200) {
                    var file = null;
                    var blob = xhr_1.response;
                    try {
                        file = new File(blob, fileName, { type: mimeType });
                    }
                    catch (err) {
                        blob.lastModifiedDate = new Date();
                        blob.name = fileName;
                        file = blob;
                    }
                    deferred.resolve({
                        file: file,
                        width: result.naturalWidth,
                        height: result.naturalHeight
                    });
                }
            };
            xhr_1.send();
        }
        return deferred;
    }
    exports.scaleImageAsFile = scaleImageAsFile;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/canvas.js
// module id = 36
// module chunks = 0